
import { Condition, ConditionPropertyType } from "@/utils/condition/condition";
import Vue from "vue";
import AppConditionValue from "@/components/models/ConditionValue.vue";
import AppConditionOperatorSelect from "@/components/models/ConditionOperatorSelect.vue";

export default Vue.extend({
	props: {
		condition: {
			type: Object as ()=>Condition,
			required: true
		},
		isEditing: Boolean,
	},
	computed: {
		propType():ConditionPropertyType{
			return ConditionPropertyType.NUMBER;
		}
	},
	methods: {
		editCondition(){
			this.$emit("edit");
		},
		removeCondition(){
			this.$emit("remove");
		}
	},
	components: {
		AppConditionValue,
		AppConditionOperatorSelect
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
